import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { getDashboardUsers, getPatientList } from "api/routes";
import { useState } from "react";
import { useEffect } from "react";
import queryString from "components/queryString";
import Loading from "components/Loading";
import { useReactToPrint } from "react-to-print";
import MDButton from "components/MDButton";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import moment from "jalali-moment";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function AdmissionPatientList({ trigger }) {
  const columns = [
    { field: "index", headerName: "ردیف", width: 70 },
    { field: "patientId", headerName: "کدپیگیری", width: 70 },
    {
      field: "reservationDate",
      headerName: "تاریخ نوبت",
      width: 150,
      valueGetter: (params) => `${params.row.reservationTime} - ${String(params.row.reservationDate).slice(0, 4)}/${String(params.row.reservationDate).slice(4, 6)}/${String(params.row.reservationDate).slice(6)}`,
    },
    {
      field: "groupName",
      headerName: "تخصص نوبت",
      width: 150,
    },
    {
      field: "isAdmission",
      headerName: "وضعیت پذیرش",
      width: 120,
      valueGetter: (params) => params.row.isAdmission ? "انجام شده" : "در انتظار",
    },
    {
      field: "admissionDate",
      headerName: "تاریخ پذیرش",
      width: 120,
      render: (params) => <p
        style={{ direction: "ltr !important", wordBreak: "break-all" }}>{params.row.admissionDate}</p>,
    },
    {
      field: "admissionUser",
      headerName: "کاربر پذیرش",
      width: 120,
    },
    {
      field: "firstName",
      headerName: "نام",
      width: 120,
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      width: 120,
    },
    {
      field: "tel",
      headerName: "تلفن ثابت",
      width: 120,
    },
    {
      field: "mobileNumber",
      headerName: "تلفن همراه",
      width: 120,
    },
    {
      field: "nationalCode",
      headerName: "کدملی",
      width: 120,
    },

  ];
  const navigate = useNavigate();
  const [patientList, setPatientList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [dashboardUsers, setDashboardUsers] = useState([]);
  const [totalRow, setTotalRow] = useState(25);
  const componentRef = React.useRef(null);
  const [selectedDay, setSelectedDay] = useState({
    from: null,
    to: null,
  });
  const [admissionFilter, setAdmissionFilter] = useState("");
  const m = moment();


  useEffect(() => {
    setLoading(true);
    let startDate = `${selectedDay?.from?.year}${String(selectedDay?.from?.month).padStart(2, "0")}${String(selectedDay?.from?.day).padStart(2, "0")}`;
    let endDate = `${selectedDay?.to?.year}${String(selectedDay?.to?.month).padStart(2, "0")}${String(selectedDay?.to?.day).padStart(2, "0")}`;

    let query = {
      from: (selectedDay?.to == null || selectedDay?.from == null) ? null : startDate,
      to: (selectedDay?.to == null || selectedDay?.from == null) ? null : endDate,
      isAdmission: 1,
      date: selectedDay.from && selectedDay.to ? null : m.locale("fa").format("YYYYMMDD"),
      page: paginationModel.page,
      pageSize: paginationModel.pageSize,
    };
    getPatientList(queryString(query), (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setTotalRow(data?.totalRowCount);
        setLoading(false);
        return setPatientList(data.data);
      }
    }, trigger !== null);
  }, [selectedDay, paginationModel, trigger]);

  useEffect(() => {
    setLoading(true);
    getDashboardUsers((isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        setDashboardUsers(data);
      }
    });
  }, []);

  const tablePrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handlePrint = useReactToPrint({
    content: tablePrintContent,
    onBeforePrint: () => setLoading(true),
    onAfterPrint: () => setLoading(false),
    removeAfterPrint: true,
    pageStyle: "@page {size: A4 landscape;margin: 0;}",
  });
  const rows = patientList.filter(row => admissionFilter ? row.admissionUser === admissionFilter : true).map((item, index) => ({ index: index + 1, ...item }));
  const renderCustomInput = ({ ref }) => (
    <input
      readOnly
      ref={ref}
      placeholder="بازه زمانی تاریخ"
      value={(selectedDay.from && selectedDay.to) ? `${selectedDay?.from?.year}/${selectedDay?.from?.month}/${selectedDay?.from?.day} - ${selectedDay?.to?.year}/${selectedDay?.to?.month}/${selectedDay?.to?.day}` : ""}
      style={{
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: "0.375rem",
        color: "#495057",
        outline: "none",
        height: "44.3px",
        width: "300px",
        fontFamily: "IRANSansX",
      }}
    />
  );

  return (
    <>
      <Loading loading={loading} />
      <MDButton onClick={() => navigate("/reservationList/print-preview", { state: { info: patientList } })}
        variant="gradient" color="info" sx={{ width: "140px", marginRight: 2 }}>
        دریافت گزارش
      </MDButton>
      <DatePicker
        value={selectedDay}
        onChange={setSelectedDay}
        renderInput={renderCustomInput}
        selectorStartingYear={Number(m?.locale("fa")?.format("YYYY"))}
        selectorEndingYear={Number(m?.locale("fa")?.format("YYYY")) + 1}
        shouldHighlightWeekends
        locale="fa"
        colorPrimary="#0fbcf9"
        colorPrimaryLight="rgba(75, 207, 250, 0.4)"
      />
      <FormControl sx={{ width: "300px", marginLeft: 2 }}>
        <InputLabel>کاربر پذیرش</InputLabel>
        <Select value={admissionFilter} onChange={(event) => setAdmissionFilter(event.target.value)}
          sx={{ height: "44.3px" }}>
          <MenuItem value={""}>همه</MenuItem>
          {dashboardUsers.map(item => item.role === "reception" &&
            <MenuItem key={item.dashboardUserId} value={item.fullname}>{item.fullname}</MenuItem>)}

        </Select>
      </FormControl>
      <div id="scrollableDiv" style={{ marginTop: 10 }}>
        <DataGrid
          rows={rows}
          ref={componentRef}
          columns={columns}
          pagination={false}
          getRowId={(item) => item.patientId}
          rowSelection={false}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rowCount={totalRow}
          paginationMode="server"
        />
      </div>
    </>
  );
}
